
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AdminAnalytics } from "./AdminAnalytics";
import { AdminConversions } from "./AdminConversions";
import { HeatmapAnalytics } from "./HeatmapAnalytics";
import { LeadManagement } from "./crm/LeadManagement";
import { DealKanban } from "./crm/deals/DealKanban";

export const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("analytics");

  return (
    <div className="p-4 md:p-6">
      <h1 className="text-2xl font-bold mb-6">Admin Dashboard</h1>
      
      <Tabs 
        value={activeTab} 
        onValueChange={setActiveTab}
        className="space-y-6"
      >
        <TabsList className="grid grid-cols-2 md:grid-cols-5 w-full">
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
          <TabsTrigger value="heatmap">Heatmap</TabsTrigger>
          <TabsTrigger value="conversions">Conversions</TabsTrigger>
          <TabsTrigger value="leads">Lead Management</TabsTrigger>
          <TabsTrigger value="deals">Deal Pipeline</TabsTrigger>
        </TabsList>
        
        <TabsContent value="analytics" className="space-y-6">
          <AdminAnalytics />
        </TabsContent>
        
        <TabsContent value="heatmap" className="space-y-6">
          <HeatmapAnalytics />
        </TabsContent>
        
        <TabsContent value="conversions" className="space-y-6">
          <AdminConversions />
        </TabsContent>
        
        <TabsContent value="leads" className="space-y-6">
          <LeadManagement />
        </TabsContent>
        
        <TabsContent value="deals" className="space-y-6">
          <DealKanban />
        </TabsContent>
      </Tabs>
    </div>
  );
};
